// @flow

import dompurify from 'dompurify';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled, { type StyledComponent } from 'styled-components';

import { GET_CONTENT } from '../../../store/actions';
import type { RootState, ContentState } from '../../../store/types';

type HtmlContentContainerRawProps = {
  className: string,
  contentKey: string,
};

const HtmlContentContainerRaw = ({ className, contentKey }: HtmlContentContainerRawProps) => {
  const sanitizer = dompurify.sanitize;
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const contentObj: ContentState = useSelector((state: RootState) => state.content);
  const language = useSelector((state: RootState) => state.i18n.language);
  const dispatch = useDispatch();

  const containerRef = useRef(null);

  useEffect(() => {
    dispatch({
      type: GET_CONTENT,
      payload: contentKey,
    });
  }, [contentKey, dispatch]);

  useEffect(() => {
    const targettedContentObj = contentObj.contents.find(item => item.key === contentKey);
    const content = targettedContentObj?.content[language] ?? '';

    setContent(content);
    setLoading(targettedContentObj ? targettedContentObj.loading : true);
  }, [contentKey, contentObj]);

  useEffect(() => {
    if (containerRef.current) {
      const links = containerRef.current.querySelectorAll('a');
      links.forEach((link) => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });
    }
  }, [content, loading]);

  return (
    <>
      <div>{loading ? 'Loading' : ''}</div>
      <div
        ref={containerRef}
        className={className}
        dangerouslySetInnerHTML={{ __html: sanitizer(content) }}
      />
    </>
  );
};

export const HtmlContentContainer: StyledComponent<{}, {}, typeof HtmlContentContainerRaw> = styled(
  HtmlContentContainerRaw,
)``;
